import component from './container'

export default component